import type { YasminaI18nDictionary } from '../schema';

const dictionary: YasminaI18nDictionary = {
    yasmina__info_block__title: 'Your personal AI assistant',
    yasmina__info_block__subtitle: 'Chat with Yasmina by yango',
    yasmina__info_block__description: 'On the app and on smart speakers',
    yasmina__info_block__cta__get_app: 'Get the Mobile App',
    yasmina__info_block__cta__learn_more: 'Learn more',
    yasmina__info_block__cta__activate_speakers: 'Activate Yasmina by Yango on smart speakers',
    yasmina__info_block__subtitle__touch: 'Chat with Yasmina by Yango',
    yasmina__info_block__cta__activate_speakers__touch: 'Activate Yasmina smart speaker',
    yasmina__qr__subtitle: 'Discover Yasmina\nanytime, anywhere',
    yasmina__qr__description: 'Scan the QR code to download the mobile app',
    yasmina__qr__cta__learn_more: 'Learn more',
    yasmina__qr__cta__next_section: 'More about Yasmina',
    yasmina__smart_home__title: 'Smart Home',
    yasmina__smart_home__subtitle: ({ brandName }) =>
        `Your Smart Home, Powered by Yasmina on the ${brandName} App`,
    yasmina__smart_home__description:
        'Seamlessly control devices, set routines, and create the perfect living environment',
    yasmina__smart_home__cta__get_app: 'Get the Mobile App',
    yasmina__smart_home__cta__learn_more: 'Learn more',
    yasmina__smart_home__cta__next_section: 'More about Yasmina',
    yasmina__promo_video__subtitle: ({ brandName }) =>
        `Connect with Yasmina Powered by YangoGPT on ${brandName}`,
    yasmina__promo_video__description:
        'Your bilingual smart assistant, available on the app and smart speakers',
    yasmina__promo_video__cta__get_mobile_app: 'Get the Mobile App',
    yasmina__promo_video__cta__get_mobile_app__touch: 'Get the Mobile app',
    yasmina__promo_video__cta__activate_speaker: 'Activate Yasmina smart speaker',
    yasmina__promo_video__cta__activate_speaker__touch: 'Activate Yasmina',
    yasmina__promo_video__cta__next_section: 'More about Yasmina',
};

export default dictionary;
